<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-modal-back></app-modal-back>
    </ion-buttons>
    <ion-title> Last Minute job </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <mable-heading heading="h2">Cancel job?</mable-heading>
  <p class="body-normal-16 ion-margin-horizontal">
    It will be deleted and workers who have made offers will be notified.
  </p>
  <p class="body-normal-16 ion-margin-horizontal">
    There is no penalty for cancelling a job before an offer is accepted.
  </p>
</ion-content>
<ion-toolbar>
  <ion-grid>
    <ion-row>
      <ion-col size="6">
        <mable-button
          expand="block"
          category="outline"
          (onClick)="modalCtrl.dismiss()"
          >Keep job</mable-button
        >
      </ion-col>
      <ion-col size="6">
        <mable-button
          expand="block"
          (onClick)="cancelJob()"
          >Cancel job</mable-button
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-toolbar>
